import { createFormAction } from 'redux-form-saga'

const getAllCarriersAction = createFormAction('GET_ALL_CARRIERS')
const getCarrierAction = createFormAction('GET_CARRIER')
const createCarrierAction = createFormAction('CREATE_CARRIER')
const updateCarrierAction = createFormAction('UPDATE_CARRIER')
const deleteCarrierAction = createFormAction('DELETE_CARRIER')

export {
  getAllCarriersAction,
  getCarrierAction,
  createCarrierAction,
  updateCarrierAction,
  deleteCarrierAction,
}
